module.exports = __webpack_public_path__ + "img/0Q3A2198_L_Black_MockedUp.93c03cf0.jpg";